export default __webpack_public_path__ + "static/media/visa2.70f10deb.svg";